<div
  *ngIf="departureTime || arrivalTime as date"
  class="card card-{{ actionType | lowercase }}"
  #dateCard
  [ngClass]="date.type | lowercase"
  (click)="openDatesDialog(actionType)"
>
  <div
    *ngIf="triangleConfig$"
    class="triangle"
    [style.width.px]="(triangleConfig$ | async).size"
    [style.height.px]="(triangleConfig$ | async).size"
    [style.left.px]="
      actionType === transportationTrackingActionType.Delivery ? -(triangleConfig$ | async).horizontalPosition : 'auto'
    "
    [style.right.px]="
      actionType === transportationTrackingActionType.Pickup ? -(triangleConfig$ | async).horizontalPosition : 'auto'
    "
  ></div>
  <div class="card__title tw-flex tw-items-center tw-justify-center">
    <ui-svg-icon
      class="transport-order-dates__icon"
      [name]="
        actionType === transportationTrackingActionType.Pickup
          ? iconNameList.BoxDelivery
          : iconNameList.DeliveryCheckmark
      "
      [width]="28"
    ></ui-svg-icon>
    {{
      'transportOrder.overview.' + (actionType === transportationTrackingActionType.Pickup ? 'departure' : 'arrival')
        | translate
    }}
  </div>

  <ui-info-field-item
    [label]="'common.field.address' | translate"
    [text]="actionType === transportationTrackingActionType.Pickup ? overview.pickup?.name : overview.delivery?.name"
  ></ui-info-field-item>

  <ui-svg-icon
    *ngIf="date.type === transportationTrackingDateType.Actual"
    class="card-finished-icon"
    [name]="iconNameList.Checkmark"
    [width]="72"
  ></ui-svg-icon>

  <ng-container *ngIf="date.values?.length > 1; else singleTimeTemplate">
    <div class="field__label">
      {{ 'transportOrder.dates.type.' + (date.type | lowercase) | translate }}
    </div>
    <ui-dates-with-divider [startDate]="date.values[0]" [endDate]="date.values[1]"></ui-dates-with-divider>
  </ng-container>

  <ng-template #singleTimeTemplate>
    <ui-info-field-item [label]="'transportOrder.dates.type.' + (date.type | lowercase) | translate">
      <ui-date-with-timezone [localDate]="date?.values[0]"></ui-date-with-timezone>
    </ui-info-field-item>
  </ng-template>
</div>
